function slugGenerator() {
    return {
        input: '',
        output: '',
        casing: 'lowercase',
        separator: '-',
        removeSpecial: true,
        removeNumbers: false,
        removeStopWords: true,
        transliterate: true,
        copied: false,
        
        stopWords: ['a', 'an', 'the', 'and', 'or', 'but', 'is', 'are', 'was', 'were', 'at', 'by', 'for', 'in', 'of', 'on', 'to', 'up', 'with'],

        init() {
            this.$watch('input', () => this.generate());
        },

        generate() {
            if (!this.input) {
                this.output = '';
                return;
            }

            let str = this.input;

            // 1. Transliterate (Simple mapping for common accents)
            if (this.transliterate) {
                str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            }

            // 2. Case Conversion
            if (this.casing === 'lowercase') {
                str = str.toLowerCase();
            } else if (this.casing === 'uppercase') {
                str = str.toUpperCase();
            }

            // 3. Remove Stop Words (only if lowercase or if we handle case insensitive matching)
            if (this.removeStopWords) {
                const words = str.split(/\s+/);
                const filtered = words.filter(word => {
                    const cleanWord = word.toLowerCase().replace(/[^a-z0-9]/g, '');
                    return !this.stopWords.includes(cleanWord);
                });
                str = filtered.join(' ');
            }

            // 4. Clean Characters
            if (this.removeSpecial) {
                // Keep letters, numbers, and spaces
                str = str.replace(/[^a-zA-Z0-9\s]/g, '');
            }
            
            if (this.removeNumbers) {
                str = str.replace(/[0-9]/g, '');
            }

            // 5. Replace Spaces with Separator
            str = str.trim();
            if (this.separator) {
                // Replace spaces with separator
                const regex = new RegExp('\\s+', 'g');
                str = str.replace(regex, this.separator);
                
                // Collapse multiple separators
                const multiSepRegex = new RegExp(`\\${this.separator}+`, 'g');
                str = str.replace(multiSepRegex, this.separator);
            } else {
                // If no separator, just remove spaces
                 str = str.replace(/\s+/g, '');
            }

            this.output = str;
        },

        copyToClipboard() {
            if (!this.output) return;
            navigator.clipboard.writeText(this.output).then(() => {
                this.copied = true;
                setTimeout(() => this.copied = false, 2000);
            });
        }
    };
}

if (typeof window.Alpine !== 'undefined') {
    Alpine.data('slugGenerator', slugGenerator);
} else {
    document.addEventListener('alpine:init', () => {
        Alpine.data('slugGenerator', slugGenerator);
    });
}
